<template>
  <div class="add-executor__form">
    <h3>Добавить исполнителя</h3>
    <a-form
      class="form"
      :model="model"
      :rules="rules"
      @finish="onFinish"
      @validate="errors.onValidate"
    >
      <a-form-item
        name="userId"
        :help="errors.getError('userId')"
        :validate-status="errors.getStatus('userId')"
      >
        <a-select
          id="executor"
          placeholder="Выберите сотрудника"
          v-model:value="model.userId"
          :options="model.usersList"
          optionFilterProp="label"
          @search="searchUser"
          showSearch
        />
      </a-form-item>

      <a-form-item class="form__button">
        <c-button-primary html-type="submit" :loading="isLoading">
          Сохранить
        </c-button-primary>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CButtonPrimary from '@/components/UI/CButtonPrimary';
  import { debounce } from 'lodash-es';
  import { useRoute } from 'vue-router';
  import { USER_STATUS_ACTIVE } from '@/constants/user-status';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['close', 'update']);

  const isLoading = ref(false);
  const model = reactive({
    usersList: [],
    userId: null,
  });

  const rules = {
    userId: [
      {
        type: 'number',
        required: true,
        message: 'Необходимо выбрать исполнителя',
        trigger: 'change',
      },
    ],
  };

  const errors = new ErrorsHandler(
    {
      userId: '',
    },
    (fieldName) => {
      if ('projectId' === fieldName) return 'userId';
      return fieldName;
    }
  );

  const usersToList = (users) => {
    return users.map((user) => ({ value: user.id, label: user.fullName }));
  };

  const searchUser = debounce(async (value) => {
    try {
      const query = new URLSearchParams();

      if ('' !== value) {
        query.set('name', value);
      }
      query.set('status', USER_STATUS_ACTIVE.toString());
      query.set('projectId', route.params.id);
      query.set('excludeProjectExecutors', 1);

      const response = await api.user.executors(query);
      model.usersList = usersToList(response.user.items);
    } catch (error) {
      console.log(error);
    }
  }, 500);

  const onFinish = async () => {
    try {
      isLoading.value = true;
      await api.projectExecutor.create({
        projectId: route.params.id,
        userId: model.userId,
      });

      emit('close');
      emit('update');
    } catch (error) {
      console.log(error);
      errors.handleApiErrors(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .add-executor__form {
    padding: 112px 17px 0 17px;

    h3 {
      font: 700 18px/26px 'Nunito Sans';
    }

    .ant-form-item {
      margin-bottom: 14px;
    }

    .form__button {
      text-align: right;
    }
  }
</style>
